import { API_AUTH } from "./common";

const DuNoGiaoNhanVienApi = {
  list: ({ tenNhanVien }) =>
    API_AUTH.get(`bao-cao/du-no-giao-nhan-vien?tenNhanVien=${tenNhanVien}`, {}),
  list1: ({ tenNhanVien, pageIndex, pageSize }) =>
    API_AUTH.get(`bao-cao/du-no-giao-nhan-vien1?tenNhanVien=${tenNhanVien}&pageIndex=${pageIndex}&pageSize=${pageSize}`, {}),
  getListChiTietDuNo: (userId, pageIndex, pageSize) =>
    API_AUTH.get(
      `bao-cao/chi-tiet-du-no-giao-nhan-vien?userId=${userId}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {}
    ),
};

export default DuNoGiaoNhanVienApi;
